import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';

import MassEmailPopup from '../components/list/MassEmailPopup';
import MassSmsPopup from '../components/list/MassSmsPopup';
import MassWhatsAppPopup from '../components/list/MassWhatsAppPopup';
import ListHeader from '../components/list/ListHeader';
import TableUI from '../components/list/TableUI';
import FilterPannel from '../components/filter/FilterPannel';
import HeaderViewList from '../components/list/HeaderViewList';

import Const from '../util/Constants';
import withRouter from '../util/WithRouter';
import ContactAPI from '../api/ContactAPI';
import KeyValueAPI from '../api/KeyValueAPI';
import ImportExportAPI from '../api/ImportExportAPI';
import Util from '../util/Util';
import Display from '../util/Display';
import ViewController from '../controller/ViewController';

class ContactList extends React.Component {

  constructor(props) {
    super(props);

    const query = new URLSearchParams(props.location.search);
    const filters = query.get("filters") ? JSON.parse(query.get("filters")) : null;

    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.contact;

    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    this.views = ViewController.getViews(Const.Contact);
    this.view = this.views.find(view => view.id === (filters ? 0 : cView.contact ? cView.contact : 0));
    if (!this.view) {
      this.view = this.views.find(view => view.type === 0);
    }

    this.lists = reactLocalStorage.getObject(Const.ListContact);
    if (!(this.lists instanceof Array)) {
      if (Object.keys(this.lists).length !== 0) {
        const lists = [];
        lists.push({ ...this.lists, view: 0 });
        this.lists = lists;
      } else {
        this.lists = [];
      }
    }
    this.setList(filters);

    this.data = { contacts: [], count: 0 };
    this.state = {
      inApiCall: true, isFilterOpen: this.list.isFilterOpen,
      massEmail: false, massSMS: false, massWhatsApp: false
    };

    this.List = Util.isAllow(this.model.permission, Const.PermView);
    this.Add = Util.isAllow(this.model.permission, Const.PermAdd);
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Restrict = Util.isAllow(this.model.permission, Const.PermRestricAcc);
  }

  componentDidMount() { if (this.List) this.loadContacts(); }

  setList = (filters) => {
    this.list = this.lists.find((list) => list.view === this.view.id);
    let fields = ['firstname', 'phone', 'email', 'address~street', 'address~city', 'responsible_person'];
    if (!this.list) {
      this.list = { view: this.view.id };
      let tmpField = reactLocalStorage.getObject(Const.FieldList);
      if (this.view.fields && this.view.fields.length > 0 && this.view.fields[0]) {
        fields = this.view.fields;
      } else if (tmpField && tmpField.contact) {
        if (typeof tmpField.contact[0] === "string" && this.view.id === 0) {
          this.list.fields = tmpField.contact;
        } else if (typeof tmpField.contact[0] === "object" && this.view.id === 0) {
          const tmp = tmpField.contact.find((item) => item.view === this.view.id);
          if (tmp) {
            fields = tmp.fields;
          }
        } else if (this.view.fields && this.view.fields.length > 0 && this.view.fields[0]) {
          fields = this.view.fields;
        }
      }
      this.list.fields = fields;
      this.list.filters = [];
      this.list.pagination = { currentPage: 1, pageCount: 1, perPage: 10 };
      this.lists.push(this.list);
    }

    if (this.view.fields && this.view.fields.length > 3 && this.view.fields[0]) {
      this.list.fields = this.view.fields;
    }

    this.list.fields = this.list.fields.filter((field) => {
      if (field.includes(Const.Opt))
        return (
          this.model.fields[field.split(Const.Opt)[0]] &&
          this.model.fields[field.split(Const.Opt)[0]].visible === Const.True
        );
      else
        return (
          this.model.fields[field] &&
          this.model.fields[field].visible === Const.True
        );
    });

    if (filters) {
      this.list.filters = filters;
    }
  };

  saveListFields = (fields) => {
    let tmpField = reactLocalStorage.getObject(Const.FieldList);
    if (tmpField.contact) {
      if (typeof tmpField.contact[0] === "string") {
        tmpField.contact = [{ fields: tmpField.contact, view: 0 }];
      }
      const tmp = tmpField.contact.find((item) => item.view === this.view.id);
      if (tmp) {
        tmp.fields = fields;
      } else {
        tmpField = { ...tmpField, contact: [...tmpField.contact, { view: this.view.id, fields }] };
      }
    } else {
      tmpField = { ...tmpField, contact: [{ view: this.view.id, fields }] };
    }
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, tmpField, () => { });
  };

  loadContacts = () => {
    reactLocalStorage.setObject(Const.ListContact, this.lists);
    const mainFilters = ViewController.getRestrictionsView(Const.Contact);
    const filters = ViewController.filters([...this.list.filters], this.view.filters, mainFilters, this.Restrict);
    this.setState({ ...this.state, inApiCall: true });
    ContactAPI.list({ ...this.list, filters }, this.onReceived, this.onFail);
  };

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    this.data.contacts = res.data;
    this.data.count = res.count;
    this.list.pagination.pageCount = Math.ceil(res.count / this.list.pagination.perPage);
    this.setState({ ...this.state, inApiCall: false });
  };

  onPageChange = currentPage => {
    this.list.pagination.currentPage = currentPage;
    this.loadContacts();
  };

  onPerPageChange = perPage => {
    this.list.pagination.perPage = perPage;
    this.loadContacts();
  };

  onFieldSelection = (fields) => {
    this.list.fields = fields;
    this.saveListFields(fields);
    this.loadContacts();
  };

  onOrderChange = (field, order) => {
    this.list.sorting = { field, order };
    reactLocalStorage.setObject(Const.ListContact, this.list);
    this.saveListSort(this.list.sorting);
    this.loadContacts();
  };

  saveListSort = sort => {
    let fieldList = reactLocalStorage.getObject(Const.FieldList);
    if (!fieldList) fieldList = {};
    fieldList = { ...fieldList, contact_sort: sort };
    let key = reactLocalStorage.getObject(Const.LoggedInUser).user_id;
    key = `${Const.FieldList}-${key}`;
    KeyValueAPI.save(key, KeyValueAPI.JSON, fieldList, () => { });
  };

  toggleFilter = () => {
    this.list.isFilterOpen = !this.state.isFilterOpen;
    reactLocalStorage.setObject(Const.ListContact, this.list);
    this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen });
  };
  onFieldChange = fields => { };
  closeFilter = () => this.setState({ ...this.state, isFilterOpen: false });
  onFilterChange = filters => { this.list.filters = filters; this.loadContacts(); };

  onAddEdit = index => {
    const i = index !== -1 ? this.data.contacts[index].id : 0;
    this.props.navigate(`${this.props.match.path}/add-edit/${i}`);
  };
  onPreview = index => {
    this.props.navigate(`${this.props.match.path}/preview/${this.data.contacts[index].id}`);
  };
  onDelete = indx => Util.confirmAlert('Delete', `Are you sure you want to delete to`
    + ` ${Display.ModelName(this.data.contacts[indx])}`, 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ContactAPI.delete(this.data.contacts[indx].id, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Contact deleted successfully', 'success');
    this.loadContacts();
  };

  import = () => this.props.navigate(`/setting/import/add?model=${Const.Contact}`);
  export = fields => Util.confirmAlert('Export', `Are you sure you want to export to with `
    + ` applied filters ? `, 'Export', 'Cancel', () => {
      this.setState({ ...this.state, inApiCall: true });
      ImportExportAPI.exportModel(Const.Contact, this.list.filters, this.list.sorting, this.data.count, fields,
        this.model.model_no, this.onExport, this.onFail);
    });
  onExport = () => {
    this.setState({ ...this.state, inApiCall: false });
    Util.showNotification('Successful', 'Contact Exported in progress.'
      + ' Please visit Settings', 'success');
  };

  onTabClick = (view) => {
    const cView = reactLocalStorage.getObject(Const.CurrentViews);
    cView.contact = view;
    reactLocalStorage.setObject(Const.CurrentViews, cView);
    if (this.view.id !== view) {
      this.view = this.views.find((item) => item.id === view);
      this.setList();
      this.loadContacts();
    }
    this.setState({ ...this.state, isFilterOpen: false });
  };

  showMassEmail = () => this.setState({ ...this.state, massEmail: !this.state.massEmail });
  showMassSMS = () => this.setState({ ...this.state, massSMS: !this.state.massSMS });
  showMassWhatsApp = () => this.setState({ ...this.state, massWhatsApp: !this.state.massWhatsApp });

  render() {
    if (!this.List) return null;
    return (
      <div>

        <MassEmailPopup show={this.state.massEmail} onHide={this.showMassEmail}
          filters={this.list.filters} model_no={Const.Contact} />

        <MassSmsPopup
          show={this.state.massSMS}
          onHide={this.showMassSMS}
          listFilters={this.list.filters}
          viewFilters={this.view.filters}
          restrict={this.Restrict}
          model_no={Const.Contact}
        />

        <MassWhatsAppPopup
          show={this.state.massWhatsApp}
          onHide={this.showMassWhatsApp}
          listFilters={this.list.filters}
          viewFilters={this.view.filters}
          restrict={this.Restrict}
          model_no={Const.Contact}
        />

        <HeaderViewList
          views={this.views}
          view={this.view}
          onTabClick={this.onTabClick}
        />

        <ListHeader
          model={this.model}
          name={this.model.label_name}
          pagination={this.list.pagination}
          listCount={this.data.count}
          filterCount={this.list.filters.length}
          onPageChange={this.onPageChange}
          perPage={this.list.pagination.perPage}
          onPerPageChange={this.onPerPageChange}
          toggleFilter={this.toggleFilter}
          onAddClick={() => this.onAddEdit(-1)}
          add={this.Add}
          import={this.import}
          export={this.export}
          showMassEmail={this.showMassEmail}
          showMassSMS={this.showMassSMS}
          showMassWhatsApp={this.showMassWhatsApp}
        />

        <div className="container-fluid ">
          <div className="row">
            <TableUI
              data={this.data.contacts}
              model={this.model}
              fields={this.list.fields}
              order={this.list.sorting}
              pagination={this.list.pagination}
              inApiCall={this.state.inApiCall}
              preview={true}
              import={this.import}
              export={this.export}
              update={this.Update}
              delete={this.Delete}
              onAddEdit={this.onAddEdit}
              onPreview={this.onPreview}
              onDelete={this.onDelete}
              onFieldSelection={this.onFieldSelection}
              onOrderChange={this.onOrderChange}
              isFilterOpen={this.state.isFilterOpen}
            />

            <FilterPannel
              filters={this.list.filters}
              fields={this.model.fields}
              onFilterChange={this.onFilterChange}
              closeFilter={this.closeFilter}
              isFilterOpen={this.state.isFilterOpen}
              restrict={this.Restrict}
            />
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(ContactList);